import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconUserGroup } from "@arco-design/web-vue/es/icon";


const routes: AppRouteRecordRaw = {
  path: '/user-control',
  redirect: '/user-control/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '用户管理',
    icon: IconUserGroup,
    // hideChildrenInMenu: true,
    order: 400,
    roles: ['authorized-org-admin', 'admin'],
    // roles: ['system-admin', 'admin'],
  },
  children: [
    {
      path: 'member-list',
      component: () => import('@/views/user-control/member-list.vue'),
      meta: {
        title: 'Atomgit 用户组',
      },
    },
    // {
    //   path: 'user-info/:id?',
    //   component: () => import('@/views/user-details/user-info.vue'),
    //   props: true,
    //   meta: {
    //     title: '个人信息',
    //     hideInMenu: true,
    //     activeMenu: '/user-details/user-info',
    //   },
    // },
    {
      path: 'index',
      component: () => import('@/views/user-control/index.vue'),
      meta: {
        title: '用户组管理',
      },
    },
    {
      path: 'group-member/:id',
      component: () => import('@/views/user-control/components/group-member.vue'),
      props: true,
      meta: {
        title: '成员列表',
        hideInMenu: true,
        ignoreCache: true,
        // noAffix: true,
        activeMenu: '/user-control/index',
      },
    },
    {
      path: 'external-user',
      component: () => import('@/views/user-control/external-user.vue'),
      meta: {
        title: '外部用户',
      },
    },
    {
      path: 'add-survey',
      component: () => import('@/views/user-control/components/external-user/add-survey.vue'),
      meta: {
        title: '添加问卷',
        hideInMenu: true,
        // ignoreCache: true,
        activeMenu: '/user-control/external-user',
      },
    },
    {
      path: 'to-channel-excel',
      component: () => import('@/views/user-control/components/external-user/to-channel-excel.vue'),
      meta: {
        title: '导入Excel',
        hideInMenu: true,
        // ignoreCache: true,
        activeMenu: '/user-control/external-user',
      },
    },
    {
      path: 'user-list-detail/:id?/:type?/:status?',
      component: () => import('@/views/user-control/components/external-user/user-list-detail.vue'),
      props: true,
      meta: {
        title: '用户列表',
        hideInMenu: true,
        // ignoreCache: true,
        activeMenu: '/user-control/external-user',
      },
    },
  ],
};

export default routes;
